import circleCheck2 from "@/assets/icons/circle-check-2.svg";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { Send2 } from "iconsax-react";
import { useAtomValue } from "jotai";
import { FC, HTMLAttributes, useState } from "react";
import SendQuizDialog from "../../components/send-quiz-dialog";

type QuizCompletedBannerProps = HTMLAttributes<HTMLDivElement>;

const badgeClassName = "rounded-full px-3 py-1 text-sm font-medium";

const QuizCompletedBanner: FC<QuizCompletedBannerProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const [showSendQuizDialog, setShowSendQuizDialog] = useState(false);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId: editionId,
  });

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: application?.quizId || "",
  });

  const handleSubmitQuiz = () => {
    setShowSendQuizDialog(true);
  };

  if (
    quiz?.status === "READY" &&
    quiz.summary.respondedQuestionsPercentage === 100
  ) {
    return (
      <>
        <Card className={cn(props.className)}>
          <CardContent className="pt-4">
            <div className="flex items-start gap-4">
              <div className="shrink-0">
                <img
                  src={circleCheck2}
                  width={20}
                  height={20}
                  className="inline-block"
                />
              </div>

              <div className="flex grow flex-col gap-2 text-[#293038]">
                <h3 className="grow text-lg">¡Cuestionario respondido!</h3>

                <p className="text-sm leading-relaxed">
                  Todas las preguntas del cuestionario han sido respondidas.
                  Asegúrate de que las evidencias estén bien documentadas y de
                  cerrar cada tema en{" "}
                  <span
                    className={cn(
                      badgeClassName,
                      "bg-[#9DE7B9] text-[#1c6c3c]",
                    )}
                  >
                    Completado total
                  </span>
                  , ya que esto facilita que el evaluador tenga toda la
                  información necesaria para realizar una calificación precisa.
                </p>
                <p className="mt-2 text-sm">
                  {quiz?.status === "READY" && (
                    <Button onClick={handleSubmitQuiz}>
                      <Send2 size={18} />
                      Enviar cuestionario
                    </Button>
                  )}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <SendQuizDialog
          showDialog={showSendQuizDialog}
          showDialogChange={setShowSendQuizDialog}
          quizId={quiz.id}
        />
      </>
    );
  }
};

export default QuizCompletedBanner;
